/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ApiResponseDbServiceGroupOSICoreTypes,
  ApiResponseList1OSICoreModelsDbServiceGroupPrivateCoreLib,
  ApiResponseList1SystemObjectPrivateCoreLib,
  DeleteApiServiceGroupActivateParams,
  DeleteApiServiceGroupIdParams,
  PostApiServiceGroupActivateParams,
  PutApiServiceGroupAccountParams,
  PutApiServiceGroupSetParamPrintDetailsParams,
  RequestsServiceGroupRequest
} from '../models';

import { axiosForReactQueryInstance } from '../../reactQuery';
import type { ErrorType, BodyType } from '../../reactQuery';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Изменить параметр Печатать детали на квитанции
 */
export const putApiServiceGroupSetParamPrintDetails = (
  params: PutApiServiceGroupSetParamPrintDetailsParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/ServiceGroup/set-param-print-details`, method: 'PUT', params },
    options
  );
};

export const getPutApiServiceGroupSetParamPrintDetailsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiServiceGroupSetParamPrintDetails>>,
    TError,
    { params: PutApiServiceGroupSetParamPrintDetailsParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiServiceGroupSetParamPrintDetails>>,
  TError,
  { params: PutApiServiceGroupSetParamPrintDetailsParams },
  TContext
> => {
  const mutationKey = ['putApiServiceGroupSetParamPrintDetails'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiServiceGroupSetParamPrintDetails>>,
    { params: PutApiServiceGroupSetParamPrintDetailsParams }
  > = (props) => {
    const { params } = props ?? {};

    return putApiServiceGroupSetParamPrintDetails(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiServiceGroupSetParamPrintDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiServiceGroupSetParamPrintDetails>>
>;

export type PutApiServiceGroupSetParamPrintDetailsMutationError = ErrorType<unknown>;

/**
 * @summary Изменить параметр Печатать детали на квитанции
 */
export const usePutApiServiceGroupSetParamPrintDetails = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiServiceGroupSetParamPrintDetails>>,
      TError,
      { params: PutApiServiceGroupSetParamPrintDetailsParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiServiceGroupSetParamPrintDetails>>,
  TError,
  { params: PutApiServiceGroupSetParamPrintDetailsParams },
  TContext
> => {
  const mutationOptions = getPutApiServiceGroupSetParamPrintDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Фаза 1: Список активированных групп для ОСИ
 */
export const getApiServiceGroupByOsiOsiId = (
  osiId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsDbServiceGroupPrivateCoreLib>(
    { url: `/api/ServiceGroup/by-osi/${osiId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiServiceGroupByOsiOsiIdQueryKey = (osiId: number) => {
  return [`/api/ServiceGroup/by-osi/${osiId}`] as const;
};

export const getGetApiServiceGroupByOsiOsiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiServiceGroupByOsiOsiIdQueryKey(osiId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>> = ({ signal }) =>
    getApiServiceGroupByOsiOsiId(osiId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiServiceGroupByOsiOsiIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>
>;
export type GetApiServiceGroupByOsiOsiIdQueryError = ErrorType<unknown>;

export function useGetApiServiceGroupByOsiOsiId<
  TData = Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiServiceGroupByOsiOsiId<
  TData = Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiServiceGroupByOsiOsiId<
  TData = Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Фаза 1: Список активированных групп для ОСИ
 */

export function useGetApiServiceGroupByOsiOsiId<
  TData = Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupByOsiOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiServiceGroupByOsiOsiIdQueryOptions(osiId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Фаза 1: Список доступных фиксированных групп для подключения
 */
export const getApiServiceGroupAvailableOsiId = (
  osiId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsDbServiceGroupPrivateCoreLib>(
    { url: `/api/ServiceGroup/available/${osiId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiServiceGroupAvailableOsiIdQueryKey = (osiId: number) => {
  return [`/api/ServiceGroup/available/${osiId}`] as const;
};

export const getGetApiServiceGroupAvailableOsiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiServiceGroupAvailableOsiIdQueryKey(osiId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>> = ({ signal }) =>
    getApiServiceGroupAvailableOsiId(osiId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiServiceGroupAvailableOsiIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>
>;
export type GetApiServiceGroupAvailableOsiIdQueryError = ErrorType<unknown>;

export function useGetApiServiceGroupAvailableOsiId<
  TData = Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiServiceGroupAvailableOsiId<
  TData = Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiServiceGroupAvailableOsiId<
  TData = Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Фаза 1: Список доступных фиксированных групп для подключения
 */

export function useGetApiServiceGroupAvailableOsiId<
  TData = Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupAvailableOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiServiceGroupAvailableOsiIdQueryOptions(osiId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Фаза 1: Создать произвольную группу
 */
export const postApiServiceGroup = (
  requestsServiceGroupRequest: BodyType<RequestsServiceGroupRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbServiceGroupOSICoreTypes>(
    {
      url: `/api/ServiceGroup`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsServiceGroupRequest,
      signal
    },
    options
  );
};

export const getPostApiServiceGroupMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiServiceGroup>>,
    TError,
    { data: BodyType<RequestsServiceGroupRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiServiceGroup>>,
  TError,
  { data: BodyType<RequestsServiceGroupRequest> },
  TContext
> => {
  const mutationKey = ['postApiServiceGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiServiceGroup>>,
    { data: BodyType<RequestsServiceGroupRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiServiceGroup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiServiceGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postApiServiceGroup>>>;
export type PostApiServiceGroupMutationBody = BodyType<RequestsServiceGroupRequest>;
export type PostApiServiceGroupMutationError = ErrorType<unknown>;

/**
 * @summary Фаза 1: Создать произвольную группу
 */
export const usePostApiServiceGroup = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiServiceGroup>>,
      TError,
      { data: BodyType<RequestsServiceGroupRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiServiceGroup>>,
  TError,
  { data: BodyType<RequestsServiceGroupRequest> },
  TContext
> => {
  const mutationOptions = getPostApiServiceGroupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Фаза 1: Обновить произвольную группу
 */
export const putApiServiceGroupId = (
  id: number,
  requestsServiceGroupRequest: BodyType<RequestsServiceGroupRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/ServiceGroup/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: requestsServiceGroupRequest
    },
    options
  );
};

export const getPutApiServiceGroupIdMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiServiceGroupId>>,
    TError,
    { id: number; data: BodyType<RequestsServiceGroupRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiServiceGroupId>>,
  TError,
  { id: number; data: BodyType<RequestsServiceGroupRequest> },
  TContext
> => {
  const mutationKey = ['putApiServiceGroupId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiServiceGroupId>>,
    { id: number; data: BodyType<RequestsServiceGroupRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiServiceGroupId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiServiceGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiServiceGroupId>>>;
export type PutApiServiceGroupIdMutationBody = BodyType<RequestsServiceGroupRequest>;
export type PutApiServiceGroupIdMutationError = ErrorType<unknown>;

/**
 * @summary Фаза 1: Обновить произвольную группу
 */
export const usePutApiServiceGroupId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiServiceGroupId>>,
      TError,
      { id: number; data: BodyType<RequestsServiceGroupRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiServiceGroupId>>,
  TError,
  { id: number; data: BodyType<RequestsServiceGroupRequest> },
  TContext
> => {
  const mutationOptions = getPutApiServiceGroupIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Фаза 1: Удалить произвольную группу (мягкое удаление)
 */
export const deleteApiServiceGroupId = (
  id: number,
  params: DeleteApiServiceGroupIdParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/ServiceGroup/${id}`, method: 'DELETE', params }, options);
};

export const getDeleteApiServiceGroupIdMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiServiceGroupId>>,
    TError,
    { id: number; params: DeleteApiServiceGroupIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiServiceGroupId>>,
  TError,
  { id: number; params: DeleteApiServiceGroupIdParams },
  TContext
> => {
  const mutationKey = ['deleteApiServiceGroupId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiServiceGroupId>>,
    { id: number; params: DeleteApiServiceGroupIdParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return deleteApiServiceGroupId(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiServiceGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiServiceGroupId>>>;

export type DeleteApiServiceGroupIdMutationError = ErrorType<unknown>;

/**
 * @summary Фаза 1: Удалить произвольную группу (мягкое удаление)
 */
export const useDeleteApiServiceGroupId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiServiceGroupId>>,
      TError,
      { id: number; params: DeleteApiServiceGroupIdParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiServiceGroupId>>,
  TError,
  { id: number; params: DeleteApiServiceGroupIdParams },
  TContext
> => {
  const mutationOptions = getDeleteApiServiceGroupIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Фаза 1: Подключить фиксированную группу к ОСИ
 */
export const postApiServiceGroupActivate = (
  params: PostApiServiceGroupActivateParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/ServiceGroup/activate`, method: 'POST', params, signal },
    options
  );
};

export const getPostApiServiceGroupActivateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiServiceGroupActivate>>,
    TError,
    { params: PostApiServiceGroupActivateParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiServiceGroupActivate>>,
  TError,
  { params: PostApiServiceGroupActivateParams },
  TContext
> => {
  const mutationKey = ['postApiServiceGroupActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiServiceGroupActivate>>,
    { params: PostApiServiceGroupActivateParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiServiceGroupActivate(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiServiceGroupActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiServiceGroupActivate>>
>;

export type PostApiServiceGroupActivateMutationError = ErrorType<unknown>;

/**
 * @summary Фаза 1: Подключить фиксированную группу к ОСИ
 */
export const usePostApiServiceGroupActivate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiServiceGroupActivate>>,
      TError,
      { params: PostApiServiceGroupActivateParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiServiceGroupActivate>>,
  TError,
  { params: PostApiServiceGroupActivateParams },
  TContext
> => {
  const mutationOptions = getPostApiServiceGroupActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Фаза 1: Отключить группу от ОСИ
 */
export const deleteApiServiceGroupActivate = (
  params: DeleteApiServiceGroupActivateParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/ServiceGroup/activate`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiServiceGroupActivateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiServiceGroupActivate>>,
    TError,
    { params: DeleteApiServiceGroupActivateParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiServiceGroupActivate>>,
  TError,
  { params: DeleteApiServiceGroupActivateParams },
  TContext
> => {
  const mutationKey = ['deleteApiServiceGroupActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiServiceGroupActivate>>,
    { params: DeleteApiServiceGroupActivateParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteApiServiceGroupActivate(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiServiceGroupActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiServiceGroupActivate>>
>;

export type DeleteApiServiceGroupActivateMutationError = ErrorType<unknown>;

/**
 * @summary Фаза 1: Отключить группу от ОСИ
 */
export const useDeleteApiServiceGroupActivate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiServiceGroupActivate>>,
      TError,
      { params: DeleteApiServiceGroupActivateParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiServiceGroupActivate>>,
  TError,
  { params: DeleteApiServiceGroupActivateParams },
  TContext
> => {
  const mutationOptions = getDeleteApiServiceGroupActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Сменить привязанный счёт для группы услуг (любой — фиксированной или произвольной)
 */
export const putApiServiceGroupAccount = (
  params: PutApiServiceGroupAccountParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/ServiceGroup/account`, method: 'PUT', params }, options);
};

export const getPutApiServiceGroupAccountMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiServiceGroupAccount>>,
    TError,
    { params: PutApiServiceGroupAccountParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiServiceGroupAccount>>,
  TError,
  { params: PutApiServiceGroupAccountParams },
  TContext
> => {
  const mutationKey = ['putApiServiceGroupAccount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiServiceGroupAccount>>,
    { params: PutApiServiceGroupAccountParams }
  > = (props) => {
    const { params } = props ?? {};

    return putApiServiceGroupAccount(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiServiceGroupAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiServiceGroupAccount>>
>;

export type PutApiServiceGroupAccountMutationError = ErrorType<unknown>;

/**
 * @summary Сменить привязанный счёт для группы услуг (любой — фиксированной или произвольной)
 */
export const usePutApiServiceGroupAccount = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiServiceGroupAccount>>,
      TError,
      { params: PutApiServiceGroupAccountParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiServiceGroupAccount>>,
  TError,
  { params: PutApiServiceGroupAccountParams },
  TContext
> => {
  const mutationOptions = getPutApiServiceGroupAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Фаза 1: Категории доходов для выбора при создании произвольной группы (parent_id=5)
 */
export const getApiServiceGroupReportCategories = (
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1SystemObjectPrivateCoreLib>(
    { url: `/api/ServiceGroup/report-categories`, method: 'GET', signal },
    options
  );
};

export const getGetApiServiceGroupReportCategoriesQueryKey = () => {
  return [`/api/ServiceGroup/report-categories`] as const;
};

export const getGetApiServiceGroupReportCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>, TError, TData>>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiServiceGroupReportCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>> = ({ signal }) =>
    getApiServiceGroupReportCategories(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiServiceGroupReportCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>
>;
export type GetApiServiceGroupReportCategoriesQueryError = ErrorType<unknown>;

export function useGetApiServiceGroupReportCategories<
  TData = Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiServiceGroupReportCategories<
  TData = Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiServiceGroupReportCategories<
  TData = Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Фаза 1: Категории доходов для выбора при создании произвольной группы (parent_id=5)
 */

export function useGetApiServiceGroupReportCategories<
  TData = Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceGroupReportCategories>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiServiceGroupReportCategoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
